var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.077 512.077",
    style: {
      enableBackground: "new 0 0 512.077 512.077"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M362.705,170.744H149.372v-21.333c-0.016-58.91,47.727-106.68,106.637-106.696c38.815-0.011,74.572,21.064,93.363,55.027   c5.72,10.303,18.71,14.019,29.013,8.299c10.303-5.72,14.019-18.71,8.299-29.013c-39.949-72.153-130.826-98.26-202.98-58.311   c-47.529,26.315-77.017,76.367-76.999,130.695v30.379c-38.826,16.945-63.944,55.259-64,97.621v128   c0.071,58.881,47.786,106.596,106.667,106.667h213.333c58.881-0.07,106.596-47.786,106.667-106.667v-128   C469.301,218.529,421.586,170.814,362.705,170.744z M277.372,362.744c0,11.782-9.551,21.333-21.333,21.333   s-21.333-9.551-21.333-21.333v-42.667c0-11.782,9.551-21.333,21.333-21.333s21.333,9.551,21.333,21.333V362.744z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlock-icon.88bf18f192c9d6bee37353e1059dd6dc.svg";
export { ForwardRef as ReactComponent };